export default __webpack_public_path__ + "static/media/anant-bg.675f844e.jpg";